<script>
import { mapActions } from 'vuex';
import { uuid } from 'vue-uuid';
import moment from 'moment';

export default {
  name: "common",
  data(){
    return {
      Theme:{
        PINK : '#f29b87',
        GREEN : '#0ba7a3',
        YELLOW : '#FBCB67',
        ORANGE : '#ED8658',
      },
      uuid
    }
  },
  computed:{
    getStoreTargetList() {
      return [
        { key : 0 , text:'APP顯示' },
        { key : 1 , text:'官網顯示' },
        { key : 2 , text:'全部顯示' },
        { key : 3 , text:'Shopline顯示' }
      ];
    },
    getStoreTypeList() {
      return [
        { key : 0 , text:'眼鏡行' },
        { key : 1 , text:'藥妝' },
        { key : 2 , text:'通路' },
      ];
    },
    getProductCategoryList() {
      return [
        { key : 0 , text:'美瞳片' },
        { key : 1 , text:'透明片' },
        { key : 2 , text:'周邊商品' },
        { key : 3, text:'彩妝商品' },
        { key : 4 , text:'生活小物' },
      ];
    },
    getDisposableList() {
      return [
        { key : -1 , text:'無' },
        { key : 0 , text:'日拋' },
        { key : 1 , text:'月拋' },
        { key : 2 , text:'月拋/日拋' },
        { key : 3 , text:'透明/日拋' },
      ];
    },
    getBaseCurveList() {
      return [
        { key : '0' , text:'無' },
        { key : '8.6mm' , text:'8.6mm' },
        { key : '8.6mm/8.7mm' , text:'8.6mm/8.7mm' },
        { key : '8.6mm/8.8mm' , text:'8.6mm/8.8mm' },
        { key : '8.6mm~8.8mm' , text:'8.6mm~8.8mm' },
        { key : '8.7mm' , text:'8.7mm' },
        { key : '8.8mm' , text:'8.8mm' },
      ];
    },
    getWaterContentList(){
      return [
        { key : '0' , text:'無' },
        { key : '38%' , text:'38%' },
        { key : '38% & 55%' , text:'38% & 55%' },
        { key : '55%' , text:'55%' },
        { key : '58%' , text:'58%' },
        { key : '60%' , text:'60%' },
      ];
    },
    getDiameterList(){
      return [
        { key : '0' , text:'無' },
        { key : '14.0mm' , text:'14.0mm' },
        { key : '14.0mm/14.2mm' , text:'14.0mm/14.2mm' },
        { key : '14.0mm~14.3mm' , text:'14.0mm~14.3mm' },
        { key : '14.1mm' , text:'14.1mm' },
        { key : '14.2mm' , text:'14.2mm' },
        { key : '14.2mm/14.3mm' , text:'14.2mm/14.3mm' },
        { key : '14.3mm' , text:'14.3mm' },
        { key : '14.4mm' , text:'14.4mm' },
        { key : '14.5mm' , text:'14.5mm' },
      ];
    },
    getProductTypes(){
      return [
        { key : 0 , text:'系列' },
        { key : 1 , text:'商品' },
      ];
    },
    getProductEnable(){
      return [
        { key : false , text:'未上架' },
        { key : true , text:'已上架' },
      ];
    },
    getCounterEnable(){
      return [
        { key : false , text:'關閉' },
        { key : true , text:'開啟' },
      ];
    },
    getHomeType(){
      return [
        { key: 0, text: '首頁輪播圖'},
        { key: 1, text: '最新消息'},
        { key: 2, text: '新品區塊'},
        { key: 3, text: '品牌介紹'},
        { key: 4, text: '風格區塊'},
        { key: 5, text: '通路Logo'},
        { key: 6, text: '實體門市'},
        { key: 7, text: '品牌Logo'},
        { key: 8, text: '首頁通路'}
      ];
    },
    getImageType(){
      return [
        { key: 0, text: '商品圖'},
        { key: 1, text: '詳情圖'},
      ];
    },
    getWatsonsOrderType(){
      return [
        {key:"all", text:"全部"},
        {key:"orderId", text:"SP訂單編號"},
        {key:"watsonsId", text:"屈臣氏訂單編號"},
        {key:"customName", text:"姓名"},
        {key:"phone", text:"電話"},
        {key:"shippingStatus", text:"出貨狀態"},
      ]
    },
    getWatsonsStatus(){
      return [
        {key:0, text:"待出貨"},
        {key:1, text:"已建立"},
        {key:-1, text:"退貨"},
      ]
    },
    getWatsonsShippingStatus(){
      return [
        {key:'1', text:"已到貨"},
        {key:'2', text:"已取貨"},
        {key:'-1', text:"驗退"},
      ]
    },
  },
  methods: {
    ...mapActions([
      'showAlert',
      'hideAlert',
    ]),

    formatDateTime(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
  }
}
</script>

<style scoped>

</style>
